import axios from 'axios';
import {
  GUEST_BOOKING,
  GUEST,
  CREW,
  BEDS_PER_ROOM_GUEST,
} from '../../service/constants.service';
import {GlobalUtility} from '../../service/global-utility.service';

const state = {
  guests: [],
  guest: [],
  newGuest: {
    firstName: '',
    middleName: '',
    lastName: '',
    suffixName: '',
    company: '',
    contactNumber: '',
    email: '',
    address: '',
  },
  guestBookedHistory: [],
  guestLatestBooked: {},

};

const mutations = {
  set_guests_list: (state, params) => {
    state.guests = params;
  },

  set_guest: (state, param) => {
    state.guest = param;
  },

  set_create_guest: (state, params) => {
    state.guests.push(params);
    state.newGuest = {
      firstName: '',
      middleName: '',
      lastName: '',
      suffixName: '',
      company: '',
      contactNumber: '',
      email: '',
      address: '',
    };
  },

  set_update_guest: (state, params) => {
    //todo
  },

  set_delete_guest: (state, params) => {
    //todo
  },

  set_null_guests: (state) => {
    state.guests = [];
  },

  set_null_guest: (state) => {
    state.guest = {};
  },

  set_null_newGuest: (state) => {
    state.newGuest = {
      firstName: '',
      middleName: '',
      lastName: '',
      suffixName: '',
      company: '',
      contactNumber: '',
      email: '',
      address: '',
    };
  },

  set_guest_booked_history : (state,params) =>{
    state.guestBookedHistory = params;
  },

  set_guest_latest_booked : (state,param) =>{
    state.guestLatestBooked = param;
  }

};

const actions = {
  async getGuestList({commit}, params) {
    return await axios.get(GUEST, {params}).then((response) => {
      commit('set_guests_list', response.data.data);
      commit('set_guest_list_pagination', response.data);
      return true;
    }).catch((error) => {
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error, 'Get Guest List');
      return false;
    });
  },

  createGuest({commit}, params) {
    return axios.post(GUEST, params).then((response) => {
      const guest = {
        guestName: response.data.last_name + ', ' + response.data.first_name +
            '' + response.data.middle_name,
        companyName: response.data.company,
        address: response.data.address,
        email: response.data.email,
        contactNumber: response.data.contact_number,
      };
      commit('set_create_guest', guest);
      return true;

    }).catch((error) => {
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error, 'Create Guest');
      return false;

    });
  },

  async viewGuestDetails({commit}, param) {
    return await axios.get(`${GUEST}/${param}`).then((response) => {
      commit('set_guest', response.data.guest);
      commit('set_guest_booked_history',response.data.booked_history);
      commit('set_guest_latest_booked',response.data.latest_booked);
      return true;
    }).catch((error) => {
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error, 'Get Guest Detail');
      return false;

    });
  },

  async updateGuest({commit}, params) {
    return await axios.put(`${GUEST}/${params.id}`, params).then((response) => {
      return true;

    }).catch((error) => {
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error, 'Update Guest Details');
      return false;

    });
  },

  async deleteGuest({commit}, param) {
    return await axios.delete(`${GUEST}/${param}`).then((response) => {
      commit('set_guest', response.data);
      return true;
    }).catch((error) => {
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error, 'DELETE GUEST');
      return false;
    });
  },

  //guest list
  setNullGuests({commit}) {
    commit('set_null_guests');
  },

  setNullGuest({commit}) {
    commit('set_null_guest');
  },

  setNullGuestBeds({commit}) {
    commit('set_null_guest_beds');
  },

};

const getters = {
  guests: state => GlobalUtility.capitalizeProperties(state.guests),
  guest: state => GlobalUtility.capitalizeProperties(state.guest),
  newGuest: state => GlobalUtility.deCapitalizeProperties(state.newGuest),
  guestBookedHistory: state => state.guestBookedHistory,
  guestLatestBooked: state => state.guestLatestBooked,

};

export default {state, actions, mutations, getters};
